/**
 *  @fileOverview Within viewport port
 *
 *  @author       Peter Schmiz <peter.schmiz@possible.com>
 *
 */

class WithinViewport {
  constructor(elem, options) {
    this.result = false;
    this.metadata = {};
    this.config = {};
    this.settings = {};
    this.isContainerTheWindow = null;
    this.elemBoundingRect = null;
    this.containerBoundingRect = null;
    this.scrollBarWidths = [0, 0];

    this.settings = options || {};

    if (typeof elem !== 'object' || elem.nodeType !== 1) {
      throw new Error('First argument must be an element');
    }

    this.elemBoundingRect = elem.getBoundingClientRect();

    this.config.container = this.settings.container || this.metadata.container || window;
    this.config.sides = this.settings.sides || this.metadata.sides || 'all';
    this.config.top = this.settings.top || this.metadata.top || 0;
    this.config.right = this.settings.right || this.metadata.right || 0;
    this.config.bottom = this.settings.bottom || this.metadata.bottom || 0;
    this.config.left = this.settings.left || this.metadata.left || 0;

    if (this.config.container === document.body || !this.config.container.nodeType === 1) {
      this.config.container = window;
    }

    this.isContainerTheWindow = (this.config.container === window);

    if (this.isContainerTheWindow) {
      this.containerBoundingRect = document.documentElement.getBoundingClientRect();
      this.containerScrollTop = document.body.scrollTop;
      this.containerScrollLeft = document.body.scrollLeft;
    } else {
      this.containerBoundingRect = this.config.container.getBoundingClientRect();
      this.containerScrollTop = this.config.container.scrollTop;
      this.containerScrollLeft = this.config.container.scrollLeft;
    }

    if (this.containerScrollLeft) {
      this.scrollBarWidths[0] = 18;
    }

    if (this.containerScrollTop) {
      this.scrollBarWidths[1] = 16;
    }
  }

  isWithin() {
    const sideNamesPattern = /^top$|^right$|^bottom$|^left$|^all$/;
    const sides = this.config.sides.split(' ');
    let i = sides.length;
    let result = false;

    while (i--) {
      const side = sides[i].toLowerCase();

      if (sideNamesPattern.test(side)) {
        if (side === 'top') {
          if (this.isWithinTop() === true) {
            result = true;
          } else {
            result = false;
            break;
          }
        }

        if (side === 'bottom') {
          if (this.isWithinBottom() === true) {
            result = true;
          } else {
            result = false;
            break;
          }
        }

        if (side === 'left') {
          if (this.isWithinLeft() === true) {
            result = true;
          } else {
            result = false;
            break;
          }
        }

        if (side === 'right') {
          if (this.isWithinRight() === true) {
            result = true;
          } else {
            result = false;
            break;
          }
        }
      }
    }

    return result;
  }

  isWithinTop() {
    if (this.isContainerTheWindow) {
      return (this.elemBoundingRect.top >= this.config.top);
    }

    return (
      this.elemBoundingRect.top >= this.containerScrollTop - (
        (this.containerScrollTop - this.containerBoundingRect.top) + this.config.top
      )
    );
  }

  isWithinBottom() {
    let containerHeight;

    if (this.isContainerTheWindow) {
      containerHeight = this.config.container.innerHeight;
    } else {
      containerHeight = this.containerBoundingRect.bottom;
    }
    return (
      this.elemBoundingRect.bottom <= containerHeight - this.scrollBarWidths[1] - this.config.bottom
    );
  }

  isWithinLeft() {
    if (this.isContainerTheWindow) {
      return (this.elemBoundingRect.left >= this.config.left);
    }
    return (
      this.elemBoundingRect.left >= this.containerScrollLeft - (
        (this.containerScrollLeft - this.containerBoundingRect.left) + this.config.left)
    );
  }

  isWithinRight() {
    if (this.isContainerTheWindow) {
      return (
        this.elemBoundingRect.right <= (
          (this.containerBoundingRect.right + this.containerScrollLeft) - this.config.right
        )
      );
    }
    return (
      this.elemBoundingRect.right <= (
        this.containerBoundingRect.right - this.scrollBarWidths[0]
      ) - this.config.right
    );
  }

  isWithinAll() {
    return (
      this.isWithinTop() &&
      this.isWithinBottom() &&
      this.isWithinLeft() &&
      this.isWithinRight()
    );
  }
}

export default WithinViewport;



// WEBPACK FOOTER //
// ./src/js/utils/within-viewport.js